
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(229|313|723)|2(058|44|471)|8(227|431|849)|7(193|414|850|92)|1484|3181|5313|5912|9927)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
